var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12533 0.375V1.16667H0.166992V2.75H0.958659V13.0417C0.958659 13.4616 1.12547 13.8643 1.42241 14.1613C1.71934 14.4582 2.12207 14.625 2.54199 14.625H10.4587C10.8786 14.625 11.2813 14.4582 11.5782 14.1613C11.8752 13.8643 12.042 13.4616 12.042 13.0417V2.75H12.8337V1.16667H8.87533V0.375H4.12533ZM2.54199 2.75H10.4587V13.0417H2.54199V2.75ZM4.12533 4.33333V11.4583H5.70866V4.33333H4.12533ZM7.29199 4.33333V11.4583H8.87533V4.33333H7.29199Z",
    fill: "#B23E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.10f851229bd7b4a927182a9de0a50fed.svg";
export { ForwardRef as ReactComponent };